import { ref } from "vue"

export function useApiRequest() {
  const output = ref("")
  const statusText = ref("")
  const statusClass = ref("badge")
  const isLoading = ref(false)
  const showOutput = ref(false)

  async function sendRequest({ url, method, fields, token }) {
    if (!token) {
      showError("Please enter an API Token at the top of the page")
      return
    }

    isLoading.value = true
    output.value = "Loading..."
    statusText.value = ""
    statusClass.value = "badge"
    showOutput.value = true

    try {
      let fetchUrl = url
      const params = new URLSearchParams()

      fields.forEach(({ name, value, pathParam }) => {
        if (!value) return
        if (pathParam) {
          fetchUrl = fetchUrl.replace(`:${name}`, value)
        } else {
          params.append(name, value)
        }
      })

      if (fetchUrl.match(/\/:\w+/)) {
        throw new Error("Please fill in all required path parameters (e.g. ID)")
      }

      if (method === "GET" && params.toString()) {
        fetchUrl += `?${params.toString()}`
      }

      output.value = `Request: ${method} ${fetchUrl}\n\nLoading...`

      const response = await fetch(fetchUrl, {
        method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })

      statusText.value = `${response.status} ${response.statusText}`
      statusClass.value = response.ok ? "badge badge-success" : "badge badge-danger"

      const data = await response.json()
      output.value = JSON.stringify(data, null, 2)
    } catch (error) {
      showError(error.message)
    } finally {
      isLoading.value = false
    }
  }

  function showError(message) {
    statusText.value = "Error"
    statusClass.value = "badge badge-danger"
    output.value = message
    showOutput.value = true
  }

  return {
    output,
    statusText,
    statusClass,
    isLoading,
    showOutput,
    sendRequest,
  }
}
